import script from "./MdmToolsSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MdmToolsSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MdmToolsSidebar.vue?vue&type=style&index=0&id=37a57945&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37a57945"]])

export default __exports__